import { render, staticRenderFns } from "./topOrder.vue?vue&type=template&id=898db89c&scoped=true&"
import script from "./topOrder.vue?vue&type=script&lang=js&"
export * from "./topOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898db89c",
  null
  
)

export default component.exports